<button
  type="button"
  (click)="goBack()"
  class="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-main mb-4 transition-colors"
  [attr.aria-label]="'common.back' | translate">
  <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
  </svg>
  <span>{{ 'common.back' | translate }}</span>
</button>
